import { ActionTitle } from "@/components/actionTitle/ActionTitle";
import { getCoworkerSettingsValue } from "@/features/workspace/customize/settings/CoworkerSettingsControl";
import {
  ScrollContainer,
  WidgetContainer,
} from "@/features/workspace/widgets/Components";
import { ONE_MONTH_END, ONE_MONTH_START } from "@/utils/dateUtils";
import { type WidgetSetting, type WidgetSize, useTasks } from "@repo/api";
import { Text } from "@repo/skapa";
import { useTranslation } from "@repo/translation";
import { localizeDateRange } from "@repo/ui";

import { CARD_HEIGHT_NORMAL, CARD_HEIGHT_TALL } from "../constants";
import { WaitingListList } from "./WaitingListList";

const getWaitingListSettings = (settings?: WidgetSetting) => {
  const unitId =
    typeof settings?.STORE === "string" ? settings.STORE : undefined;

  const { email, teamId } = getCoworkerSettingsValue(
    settings?.COWORKER?.toString() ?? ""
  );

  // Default date range
  const dueDateRange = [ONE_MONTH_START, ONE_MONTH_END];

  return { unitId, email, teamId, dueDateRange };
};

export const WaitingListWidget = ({
  title,
  size,
  settings,
}: {
  title: string;
  size: WidgetSize;
  settings?: WidgetSetting;
}) => {
  const { unitId, email, teamId, dueDateRange } =
    getWaitingListSettings(settings);
  const { dateFnsLocale } = useTranslation();

  const { data } = useTasks({
    subTaskType: "waitingListBackInStock",
    fromDate: dueDateRange[0],
    toDate: dueDateRange[1],
    unitId,
    emails: email,
    teamId,
  });

  const list = data?.filter((el) => el.isDone === false) ?? [];

  return (
    <WidgetContainer
      size={size === "M" ? CARD_HEIGHT_TALL : CARD_HEIGHT_NORMAL}
    >
      <ActionTitle title={`${title} (${list?.length ?? 0})`} />
      <Text>
        {localizeDateRange(dueDateRange[0], dueDateRange[1], dateFnsLocale)}
      </Text>
      <ScrollContainer overflowY="auto">
        <WaitingListList list={list} />
      </ScrollContainer>
    </WidgetContainer>
  );
};
